<script setup>
import { ref } from "vue";

import Modal from "@/components/Modal";

const props = defineProps(
  {
    method: { required: true },
    args: { required: false },
    btnContent: { required: false, default: '' }
  });

const error = ref(false);
const error_text = ref(String);

async function handleClick() {
  const propMethod = props.method;
  const response = await propMethod(props.args);

  if (!response) {
    toggleModal();
    return;
  };

  if ('data' in response) {

    if (response.data.deleted == true) {
      toggleModal();
      error.value = false;
      return;

    } else {
      error_text.value = response.data.message;
      error.value = true;
      return;
    }

  } else if (response.status !== 200) {

    error_text.value = response.message;
    error.value = true;

  } else {
    error.value = false;
    toggleModal();
  }
}



const modalOpen = ref(false);

function toggleModal() {
  modalOpen.value = !modalOpen.value;
  error.value = false;
}

</script>

<template>
  <div class="button--danger" @click="modalOpen = true">

    <slot name="btn-content">
      {{ props.btnContent }}
    </slot>

  </div>
  <Modal :active="modalOpen" @toggle="toggleModal">
    <div v-if='!error' class="modal-confirm">
      <p class="modal-text">
        <slot name="modal-text">
          Are you sure?
        </slot>
      </p>
      <div class="buttons">
        <button class="button button--danger" @click="handleClick">Yes</button>
        <button class="button button--bordered" @click="toggleModal">Cancel</button>
      </div>
    </div>
    <div v-else class="modal-confirm">
      <p class="modal-text"> {{ error_text }} </p>
      <div class="buttons">
        <div class="dummy"></div>
        <button class="button button--bordered" @click="toggleModal">OK</button>
      </div>
    </div>
  </Modal>
</template>

<style scoped lang="scss">
.buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.modal-text {
  margin-bottom: 20px;
}
</style>
